import { render, staticRenderFns } from "./feedBackIndex.vue?vue&type=template&id=70cc4118&scoped=true"
import script from "./feedBackIndex.vue?vue&type=script&lang=js"
export * from "./feedBackIndex.vue?vue&type=script&lang=js"
import style0 from "./feedBackIndex.vue?vue&type=style&index=0&id=70cc4118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc4118",
  null
  
)

export default component.exports